import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFab,
  IonFabButton,
  IonFabList,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonRow,
  IonSearchbar,
  IonSegment,
  IonSegmentButton,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  useIonViewWillLeave,
} from "@ionic/react";
import {
  add,
  ellipsisHorizontal,
  folderOpen,
  folderOpenOutline,
  informationCircle,
  list,
  statsChart,
} from "ionicons/icons";
import React, {
  Dispatch,
  createRef,
  useContext,
  useEffect,
  useRef,
  useState,
  memo,
} from "react";
import { RouteProps } from "react-router";
import { v4 as uuidv4 } from "uuid";
import { TradingGridGroupLiveView } from "./interfaces";
import config from "../../../components/helpers/socket/config";
import { pubsubEvents } from "../../../components/helpers/socket/pubsubEvent";
import ShowInMobileErrorBackdrop from "../../../utils/component-utils/ErrorBackdrop/ShowInMobileErrorBackdrop";
import firebaseEventConfig from "../../../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../../../utils/firebaseAnalytics/firebaseUtils";
import { send } from "../../../utils/sockets/asyncSocket";
import { CMEDPermissions } from "./MarketDataContent";
import NewMarketDataListItem from "./NewMarketDataListItem";
import OrderEntryModal from "./OrderEntryModal";
import UserPreferencesContext, {
  UserPreferences,
} from "../../../components/contexts/UserPreferencesContext";
import {
  getCapacitorPreference,
  setCapacitorPreference,
} from "../../../utils/core-utils/capPreferencesUtils";
import {
  CapacitorPreferencesConstants,
  MetricConstants,
  MetricTypeConstants,
} from "../../../components/Constants";
import { isEmpty } from "underscore";
import { EditGridsModal } from "./EditGridsModal";
import { saveUserPreferences } from "../../../utils/core-utils/preferenceUtils";
import { tradingGridGroupGetter } from "../../../utils/commonUtils";
import Skeleton__MarketData from "./Skeleton__MarketData";
import { startMetric } from "../../../utils/metric-utils/metricUtils";

interface MarketDataContainerProps extends RouteProps {
  tradingGridGroup: any[] | undefined;
  setTradingGridGroup: any;
  tradingGridGroupData: any[];
  tradingGridGroupLiveView: TradingGridGroupLiveView[];
  setTradingGridGroupLiveView: Dispatch<
    React.SetStateAction<TradingGridGroupLiveView[]>
  >;
  userCMEDEntitlements: CMEDPermissions | undefined;
  setIsSnapshot: any;
  isCMEDLoggedIn: boolean;
  setSendRequest: Dispatch<any>;
  sendRequest: any[];
  isSnapshot: any;
  currentSelectedProfile: number | undefined;
  isLoadingMarketData: boolean;
  setIsLoadingMarketData: Dispatch<React.SetStateAction<boolean>>;
}

type AllContracts = {
  id: string;
  n: string;
  c: string;
  ci: string;
  g: string;
  i: string;
  iu: string;
};

type Strategies = {
  id: string;
  n: string;
  s: string;
};

type Periods = {
  id: string;
  n: string;
  s: string;
};

type Contracts = {
  id: string;
  n: string;
  c: string;
  ci: string;
  g: string;
  i: string;
  iu: string;
};

type FinalInstrument = {
  id: string;
  n: string;
  fpt: string;
  tsrat: string;
};
const MarketDataContainer: React.FC<MarketDataContainerProps> = ({
  userCMEDEntitlements,
  setIsSnapshot,
  tradingGridGroup,
  setTradingGridGroup,
  tradingGridGroupData,
  tradingGridGroupLiveView,
  setTradingGridGroupLiveView,
  isCMEDLoggedIn,
  setSendRequest,
  sendRequest,
  isSnapshot,
  currentSelectedProfile,
  isLoadingMarketData,
  setIsLoadingMarketData,
}) => {
  const reqIdref = useRef("");
  const [currentTradingGroup, setCurrentTradingGroup] = useState<any>();
  const selectedTradingGroupValue = useRef<any>();

  const [currentTradingGroupData, setCurrentTradingGroupData] =
    useState<any[]>();

  const modal = useRef<HTMLIonModalElement>(null);
  const page = useRef(null);

  const [contractStep, setcontractStep] = useState(0);
  const [allContracts, setAllContracts] = useState<Array<AllContracts>>();
  const [strategies, setStrategies] = useState<Array<Strategies>>();
  const [periods, setPeriods] = useState<Array<Periods>>();

  const [selectedInstrumentId, setselectedInstrumentId] = useState();
  const [selectedStrategyId, setselectedStrategyId] = useState();

  const [finalContracts, setFinalContracts] = useState<Array<Contracts>>();

  const [showNoContractsMessage, setShowNoContractsMessage] = useState(false);
  const [contractRetrievalStarted, setContractRetrievalStarted] =
    useState(false);

  const [presentingElement, setPresentingElement] =
    useState<HTMLElement | null>(null);

  const [contractSearchVal, setContractSearchVal] = useState("");
  const [strategySearchVal, setStrategySearchVal] = useState("");
  const [periodSearchVal, setPeriodSearchVal] = useState("");
  const [finalContractSearchVal, setFinalContractSearchVal] = useState("");

  const [orderEntryType, setOrderEntryType] = useState<string>();
  const [openOrderEntryModal, setOpenOrderEntryModal] = useState(false);
  // const [openOrderAggressionModal, setopenOrderAggressionModal] =
  //   useState(false);
  const [orderEntryData, setOrderEntryData] = useState<any>();
  const [orderEntryData_Live, setOrderEntryData_Live] = useState<any>();
  const [selectedOrderAgressionItem, setselectedOrderAgressionItem] =
    useState<any>([]);
  const [orderAggression, setorderAggression] = useState("");
  const [addContractModalOpen, setAddContractModalOpen] = useState(false);
  const [isEditGridsModalOpen, setIsEditGridsModalOpen] =
    useState<boolean>(false);
  const [fabButtonOptions, setFabButtonOptions] = useState<boolean>(false);
  const { userPreferences, setUserPreferences } = useContext(
    UserPreferencesContext,
  );
  const [priceType, setpriceType] = useState(undefined);
  const [
    selectedFutureContractsCheckboxes,
    setSelectedFutureContractsCheckboxes,
  ] = useState<string[]>([]);
  const [forwardMonths, setForwardMonths] = useState<number>(1);
  const [deletedGrids, setDeletedGrids] = useState<string[] | undefined>(
    undefined,
  );
  const [addedOrUpdatedGrid, setAddedOrUpdatedGrid] = useState(undefined);

  const searchRef = createRef<HTMLIonSearchbarElement>();

  const contractMonthsOptions = [
    { name: "3 Months", value: 0.25 },
    { name: "6 Months", value: 0.5 },
    { name: "1 Year", value: 1 },
    { name: "2 Years", value: 2 },
    { name: "3 Years", value: 3 },
    { name: "5 Years", value: 5 },
    { name: "10 Years", value: 10 },
    { name: "20 Years", value: 20 },
  ];
  const defaultMonths = 12;

  function getAllContracts() {
    const request = {
      action: config.socket.actions.CMED_PRODUCTS,
      requestID: uuidv4(),
      type: "notUsedButMustBePresentForLegacyValidation",
      payload: {},
    };

    send(config.socket.channels.TRADING, request);
  }

  function subscribeTradingGridGroupItemMarketData() {
    setIsLoadingMarketData(true);
    let request = {
      action: "cmed/orders/subscribe",
      type: "ordersDataSubscribe",
      requestID: uuidv4(),
      payload: {
        ordersDataType: "TradingGridGroupItemMarketDataV2",
        groupId: selectedTradingGroupValue.current,
      },
    };
    selectedTradingGroupValue.current &&
      send(config.socket.channels.TRADING, request);
  }

  function unsubscribeTradingGridGroupItemMarketData(
    previouslySelectedTradingGroupValue: any,
  ) {
    let request = {
      action: "cmed/orders/unsubscribe",
      type: "ordersDataUnSubscribe",
      requestID: uuidv4(),
      payload: {
        ordersDataType: "TradingGridGroupItemMarketDataV2",
        groupId: previouslySelectedTradingGroupValue,
      },
    };
    previouslySelectedTradingGroupValue &&
      send(config.socket.channels.TRADING, request);
  }

  useEffect(() => {
    if (
      userPreferences &&
      userPreferences.app_tour &&
      userPreferences.app_tour !== "" &&
      typeof userPreferences.app_tour === "string"
    ) {
      const appTour = JSON.parse(userPreferences.app_tour);
      setFabButtonOptions(appTour?.market === false);
    }
  }, [userPreferences?.app_tour]);

  useIonViewWillLeave(() => {
    setFabButtonOptions(false);
  });

  useEffect(() => {
    setTimeout(() => {
      addContractModalOpen && searchRef.current?.setFocus();
    }, 750);
  }, [addContractModalOpen]);

  function updateGridGroupPreference() {
    selectedTradingGroupValue.current &&
      setCapacitorPreference(
        CapacitorPreferencesConstants.MARKET_DATA_GRID_ID,
        selectedTradingGroupValue.current,
      );
    selectedTradingGroupValue.current &&
      subscribeTradingGridGroupItemMarketData();
  }

  function getStrategy(instrumentId: string) {
    const request = {
      action: config.socket.actions.CMED_STRATEGIES,
      requestID: uuidv4(),
      type: "notUsedButMustBePresentForLegacyValidation",
      payload: {
        instrumentId: instrumentId,
      },
    };

    send(config.socket.channels.TRADING, request);
  }

  const handleCheckboxChange = (event: any): void => {
    const value: string = event.target.value;
    const isChecked: boolean = event.target.checked;

    if (isChecked) {
      setSelectedFutureContractsCheckboxes([
        ...selectedFutureContractsCheckboxes,
        value,
      ]);
    } else {
      setSelectedFutureContractsCheckboxes(
        selectedFutureContractsCheckboxes.filter((item: any) => item !== value),
      );
    }
  };

  function getContractsForInstrument(
    strategyId: any,
    instrumentId: any,
    forwardMonths: number,
  ) {
    let reqId = uuidv4();
    const request = {
      action: config.socket.actions.CMED_GET_CONTRACTS,
      requestID: reqId,
      type: "notUsedButMustBePresentForLegacyValidation",
      payload: {
        instrumentId: selectedInstrumentId,
        strategyId: strategyId,
        contractMonths: defaultMonths * forwardMonths,
      },
    };
    reqIdref.current = reqId;
    setFinalContracts(undefined);
    setContractRetrievalStarted(true); // Mark retrieval as started
    setShowNoContractsMessage(false); // Hide the "no contracts" message initially.
    startMetric(
      MetricConstants.CONTRACTS_FETCH_LATENCY,
      MetricTypeConstants.TIMER,
    );
    send(config.socket.channels.TRADING, request);
  }

  function onNewContractFetchSuccess(res: any) {
    const reqID: string = res.requestID;
    if (
      reqIdref !== undefined &&
      reqIdref.current === reqID &&
      res &&
      res.payload !== null
    ) {
      setFinalContracts((finalContracts) => {
        let contracts: any[] = finalContracts ? [...finalContracts] : []; // Create a copy or a new array
        let payloads = res.payload;
        for (let payload of payloads) {
          const newContract = payload;
          const existingContract = contracts.find(
            (item) => item.id === newContract.id,
          );
          if (!existingContract) {
            // Only add if it doesn't already exist
            contracts.push(newContract);
          }
        }
        return contracts;
      });
    } else {
      setFinalContracts(undefined);
    }
    setContractRetrievalStarted(false); // Retrieval complete, regardless of success/failure
  }

  function addInstrumentToGrid() {
    let reqId = uuidv4();
    const request = {
      action: config.socket.actions.CMED_ADD_CONTRACTS,
      requestID: reqId,
      type: "notUsedButMustBePresentForLegacyValidation",
      payload: {
        itemId: selectedFutureContractsCheckboxes,
        groupId: selectedTradingGroupValue.current,
      },
    };
    setSendRequest(request);
    send(config.socket.channels.TRADING, request);
    for (
      let index = 0;
      index < selectedFutureContractsCheckboxes?.length;
      index++
    ) {
      CMEDfirebaseLogEvent(
        firebaseEventConfig.CMEDComponentNames.CMED_MARKET_DATA,
        firebaseEventConfig.eventNames.CMED_MARKET_DATA
          .CMED_MARKET_DATA_ADD_NEW_CONTRACT,
      );
    }
  }

  async function updateTradingGridGroups(data: any, res: any) {
    console.log("## Trading Grid Groups Data", res?.payload);

    const MD__gridGroupId = await getCapacitorPreference(
      CapacitorPreferencesConstants.MARKET_DATA_GRID_ID,
    );

    const payload = res.payload;
    setIsSnapshot(payload.isSnapshot);
    setIsLoadingMarketData(false);

    if (isEmpty(payload.data) && isEmpty(payload.deletions)) {
      setTradingGridGroup([]);
      setTradingGridGroupLiveView([]);
      return;
    }

    if (payload?.isSnapshot === null) {
      setAddedOrUpdatedGrid(payload?.data[0]?.id);
    }

    let gridDeleted = false,
      gridExists = false;

    if (payload.deletions.length) {
      setDeletedGrids(payload.deletions);
      setTradingGridGroup((prevObjects: any) => {
        const updatedObjects = [...prevObjects]; // Create a copy of the existing objects

        console.log("UPDATED OBJS - DELETE DATA _ GGROUP", updatedObjects);

        for (const update of payload.deletions) {
          console.log("DELETIONSSSS ", update);

          // Find the object with the matching identifier
          const objectIndex = updatedObjects.findIndex(
            (obj) => obj.id === update,
          );

          // Find if the selected grid has been deleted
          if (MD__gridGroupId === update) {
            gridDeleted = true;
          }

          console.log("DELETIONS OBJ INDEX", objectIndex);
          if (objectIndex !== -1) {
            updatedObjects.splice(objectIndex, 1);
          }
        }

        if (gridDeleted) {
          const firstGrid =
            updatedObjects && updatedObjects.length > 0
              ? updatedObjects[0]
              : undefined;
          setCurrentTradingGroup(firstGrid?.id);
          selectedTradingGroupValue.current = firstGrid?.id;
          updateGridGroupPreference();
          unsubscribeTradingGridGroupItemMarketData(MD__gridGroupId);
          setCapacitorPreference(
            CapacitorPreferencesConstants.MARKET_DATA_GRID_ID,
            firstGrid?.id,
          );
        } else {
          setCurrentTradingGroup(MD__gridGroupId);
          selectedTradingGroupValue.current = MD__gridGroupId;
          updateGridGroupPreference();
        }
        return updatedObjects;
      });

      setTradingGridGroupLiveView((prev) => {
        const newLiveViewData = [...prev];
        for (const delGroup of payload.deletions) {
          const index = newLiveViewData.findIndex(
            (ele) => ele?.id === delGroup,
          );
          if (index != -1) {
            newLiveViewData.splice(index, 1);
          }
        }
        return newLiveViewData;
      });

      return;
    }

    if (payload.isSnapshot) {
      let objIndex = -1;
      if (MD__gridGroupId) {
        objIndex = payload?.data?.findIndex(
          (item: any) => item.id === MD__gridGroupId,
        );
      }
      if (objIndex === -1) {
        setCurrentTradingGroup(payload?.data[0]?.id);
        MD__gridGroupId &&
          unsubscribeTradingGridGroupItemMarketData(MD__gridGroupId);
        selectedTradingGroupValue.current = payload?.data[0]?.id;
        updateGridGroupPreference();
      } else {
        setCurrentTradingGroup(MD__gridGroupId ?? payload?.data[0]?.id);
        selectedTradingGroupValue.current =
          MD__gridGroupId ?? payload?.data[0]?.id;
        selectedTradingGroupValue.current =
          MD__gridGroupId ?? payload?.data[0]?.id;
        updateGridGroupPreference();
      }

      setTradingGridGroup(payload.data);
      const tradeGridIds = payload.data?.map((trdeGridItem: any) => {
        return trdeGridItem.id;
      });

      setTradingGridGroupLiveView((prev) => {
        return prev.filter((entry) => tradeGridIds.includes(entry.id));
      });
    } else {
      // add another trading grid group
      console.log("payload.data", payload);

      setTradingGridGroup((prevObjects: any) => {
        let updatedObjects = [...prevObjects]; // Create a copy of the existing objects

        console.log("UPDATED OBJS - OLD DATA _ GGROUP", updatedObjects);

        // Find the object with the matching identifier of selected grid
        const selectedObjectIndex = updatedObjects.findIndex(
          (obj) => obj.id === MD__gridGroupId,
        );

        if (selectedObjectIndex !== -1) {
          gridExists = true;
        }

        for (const update of payload.data) {
          const existingIndex = updatedObjects.findIndex(
            (item) => item.id === update.id,
          );

          if (existingIndex === -1) {
            updatedObjects.push(update);
          } else {
            updatedObjects[existingIndex] = update;
          }
        }

        if (!gridExists) {
          setCurrentTradingGroup(payload?.data[0]?.id);
          selectedTradingGroupValue.current = payload?.data[0]?.id;
          updateGridGroupPreference();
          setCapacitorPreference(
            CapacitorPreferencesConstants.MARKET_DATA_GRID_ID,
            payload?.data[0]?.id,
          );
        }
        return updatedObjects;
      });
    }
  }

  useEffect(() => {
    setPresentingElement(page.current);
    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_TRADING_GRID_GROUPS_UPDATE,
      (data, res) => {
        updateTradingGridGroups(data, res);
      },
    );

    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ALL_PRODUCTS_SUCCESS,
      (data, res) => {
        setAllContracts(res.payload?.filter((item: any) => !item?.i));
      },
    );

    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ALL_PRODUCTS_FAILURE,
      (data, res) => {
        setAllContracts(undefined);
      },
    );

    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_ORDER_INSTRUMENTS_UPDATE,
      (data, res) => {
        allContracts?.length === 0 &&
          setAllContracts(res.payload?.filter((item: any) => !item?.i));
      },
    );

    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ADD_CONTRACTS_SUCCESS,
      (data) => {
        onContractSuccess(data);
      },
    );
    // PubSub.subscribe(pubsubEvents.socketKeys.CMED_ADD_CONTRACTS_FAILURE, (data) => { onContractFailure(data) })

    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_STRATEGIES_SUCCESS,
      (data, res) => {
        setStrategies(res.payload);
      },
    );
    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_STRATEGIES_FAILURE,
      (data, res) => {
        setStrategies(undefined);
      },
    );

    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ALL_PERIODS_SUCCESS,
      (data, res) => {
        setPeriods(res.payload);
      },
    );
    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ALL_PERIODS_FAILURE,
      (data, res) => {
        setPeriods(undefined);
      },
    );

    // TODO
    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ALL_CONTRACTS_SUCCESS,
      (data, res) => {
        onNewContractFetchSuccess(res);
      },
    );
    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ALL_CONTRACTS_FAILURE,
      (msg, data) => {
        // setFinalContracts(undefined);
        setContractRetrievalStarted(false); // Retrieval complete
      },
    );
  }, []);

  useEffect(() => {
    isCMEDLoggedIn && getAllContracts();
  }, [isCMEDLoggedIn]);

  function onContractSuccess(response: any) {
    // if (this.options.requestID === response.requestID) {
    //   this.set({
    //     addContractRequest: false,
    //     addContractSuccess: true,
    //     contractId: response.payload.itemId
    //   })
    // }
  }

  useEffect(() => {
    let arr: any[] = [];
    tradingGridGroupData?.map((item) => {
      if (item.identifier?.toString() === currentTradingGroup) {
        item.data.map((item1: any) => {
          arr.push(item1);
        });
      }
    });
    setCurrentTradingGroupData(arr);
  }, [currentTradingGroup, tradingGridGroupData]);

  const RenderMobileHeader = () => {
    return (
      <IonItem
        className="ion-no-padding"
        lines="none"
        style={{
          "--inner-padding-end": 0,
          "--min-height": "0px",
          "--background": "none",
          marginTop: "2px",
        }}
      >
        <div className="md__header_parent">
          <div className="md__contract_side_status_header">
            CONTRACT
            <br />
            LAST / CHANGE / VOLUME
          </div>
          <div className="md__bid_bidqty_header">
            BID
            <br />
            QTY
          </div>
          <div className="md__offer_offerqty_header">
            OFFER
            <br />
            QTY
          </div>
        </div>
      </IonItem>
    );
  };

  const AddNewCOntractCommonHeader = ({ code, name }: any) => {
    return (
      <IonItem>
        <IonGrid>
          <IonRow>
            <IonCol
              className="ion-text-bold"
              style={{ color: "var(--ion-color-primary)" }}
            >
              {" "}
              {code}{" "}
            </IonCol>
            <IonCol
              className="ion-text-bold"
              style={{ color: "var(--ion-color-primary)" }}
            >
              {name}{" "}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonItem>
    );
  };

  const AddNewContractHeader = () => {
    return (
      <>
        {contractStep === 0 && (
          <AddNewCOntractCommonHeader code={"Code"} name={"Product Name"} />
        )}
      </>
    );
  };

  const doFilterItOut = (data: any, searchString: any, type: any) => {
    const monthAbbreviations = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    const isMonthly = (contractName: string) => {
      const parts = contractName.split(" ");
      if (parts.length > 0) {
        // Check if there are any parts after split
        const lastPart = parts[parts.length - 1].toUpperCase(); // Consider last part
        return (
          monthAbbreviations.some((abbr) => lastPart.startsWith(abbr)) &&
          /\d{2,4}$/.test(lastPart)
        );
      }
      return false;
    };

    const seasonKeywords = ["winter", "spring", "summer", "fall"];
    const isSeason = (contractName: string) =>
      seasonKeywords.some((keyword) =>
        contractName.toLowerCase().includes(keyword),
      );

    const isQuarterly = (contractName: string) =>
      contractName.toLowerCase().split(" ").pop()?.includes("q"); // Check last word for "q"

    const isAnnual = (contractName: string) => /\d{4}/.test(contractName); // Check for YYYY

    const hasHyphen = (contractName: string) => {
      const firstWord = contractName.split(" ")[0];
      const restOfName = contractName.substring(firstWord.length).trim(); // Get the part after the first word

      return restOfName.includes("-"); // Check for hyphen in the rest of the name (except 1st word to avoid contracts like "3-Month SOFR Future Feb25")
    };

    const monthlyContracts = data?.filter(
      (item: any) =>
        isMonthly(item.n) &&
        !isSeason(item.n) &&
        !isQuarterly(item.n) &&
        !hasHyphen(item.n),
    );

    const otherContracts = data?.filter(
      (item: any) =>
        !isMonthly(item.n) ||
        isSeason(item.n) ||
        isQuarterly(item.n) ||
        hasHyphen(item.n),
    );

    // Sort: Monthly contracts by month and year
    monthlyContracts?.sort((a: any, b: any) => {
      const monthOrder = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];

      const getMonthAndYear = (contractName: string) => {
        const parts = contractName.split(" ");
        const monthYearPart = parts[parts.length - 1].toUpperCase();
        const month = monthYearPart.slice(0, 3);
        const year = monthYearPart.slice(3); // Extract year (YY or YYYY)
        return { month, year };
      };

      const aMonthYear = getMonthAndYear(a.n);
      const bMonthYear = getMonthAndYear(b.n);

      // Compare years first
      const yearComparison =
        parseInt(aMonthYear.year) - parseInt(bMonthYear.year);
      if (yearComparison !== 0) {
        return yearComparison;
      }

      // If years are the same, compare months
      const aMonthIndex = monthOrder.indexOf(aMonthYear.month);
      const bMonthIndex = monthOrder.indexOf(bMonthYear.month);
      return aMonthIndex - bMonthIndex;
    });

    // Sort: Regular contracts first, then special ones
    otherContracts?.sort((a: any, b: any) => {
      const aIsSpecial = isQuarterly(a.n);
      const bIsSpecial = isQuarterly(b.n);

      if (aIsSpecial && !bIsSpecial) return 1; // a is special, b is not: a goes to bottom
      if (!aIsSpecial && bIsSpecial) return -1; // a is not special, b is: a goes to top
      return 0; // Both are the same type, maintain original order
    });
    otherContracts?.sort((a: any, b: any) => {
      const aIsSpecial = isAnnual(a.n);
      const bIsSpecial = isAnnual(b.n);

      if (aIsSpecial && !bIsSpecial) return 1; // a is special, b is not: a goes to bottom
      if (!aIsSpecial && bIsSpecial) return -1; // a is not special, b is: a goes to top
      return 0; // Both are the same type, maintain original order
    });
    otherContracts?.sort((a: any, b: any) => {
      const aIsSpecial = isSeason(a.n);
      const bIsSpecial = isSeason(b.n);

      if (aIsSpecial && !bIsSpecial) return 1; // a is special, b is not: a goes to bottom
      if (!aIsSpecial && bIsSpecial) return -1; // a is not special, b is: a goes to top
      return 0; // Both are the same type, maintain original order
    });
    otherContracts?.sort((a: any, b: any) => {
      const aIsSpecial = hasHyphen(a.n);
      const bIsSpecial = hasHyphen(b.n);

      if (aIsSpecial && !bIsSpecial) return 1; // a is special, b is not: a goes to bottom
      if (!aIsSpecial && bIsSpecial) return -1; // a is not special, b is: a goes to top
      return 0; // Both are the same type, maintain original order
    });

    data = monthlyContracts?.concat(otherContracts);

    if (
      searchString === "" ||
      searchString === undefined ||
      searchString === null
    )
      return data;
    if (type === "Contracts")
      return data?.filter((item: any) =>
        item?.n?.toLowerCase().includes(searchString.toLocaleLowerCase()),
      );
    if (type === "Periods")
      return data?.filter(
        (item: any) =>
          item?.n?.toLowerCase().includes(searchString.toLocaleLowerCase()), //filtering out item on the basis of 'n' that includes userinput
      );
    const filteredData = data //filtering out item on the basis of 'c' that starts with userinput followed by items that include userinput followed by filtering out item on the basis of 'id' that includes userinput or userinput preceded by whitespace, /, ., (, -, or comma
      ?.filter((item: any) =>
        item?.c?.toLowerCase().startsWith(searchString.toLocaleLowerCase()),
      )
      .concat(
        data?.filter(
          (item: any) =>
            !item?.c
              ?.toLowerCase()
              .startsWith(searchString.toLocaleLowerCase()) &&
            item?.c?.toLowerCase().includes(searchString.toLocaleLowerCase()),
        ),
      )
      .concat(
        data?.filter(
          (item: any) =>
            !item?.c
              ?.toLowerCase()
              .includes(searchString.toLocaleLowerCase()) &&
            (item?.id
              ?.toLowerCase()
              .includes(" " + searchString.toLocaleLowerCase()) ||
              item?.id
                ?.toLowerCase()
                .includes("/" + searchString.toLocaleLowerCase()) ||
              item?.id
                ?.toLowerCase()
                .includes("." + searchString.toLocaleLowerCase()) ||
              item?.id
                ?.toLowerCase()
                .includes("(" + searchString.toLocaleLowerCase()) ||
              item?.id
                ?.toLowerCase()
                .includes("-" + searchString.toLocaleLowerCase()) ||
              item?.id
                ?.toLowerCase()
                .includes("," + searchString.toLocaleLowerCase()) ||
              item?.id
                ?.toLowerCase()
                .indexOf(searchString.toLocaleLowerCase()) === 0),
        ),
      )
      .concat(
        data?.filter(
          (item: any) =>
            !item?.c
              ?.toLowerCase()
              .includes(searchString.toLocaleLowerCase()) &&
            !item?.id
              ?.toLowerCase()
              .includes(searchString.toLocaleLowerCase()) &&
            (item?.n
              ?.toLowerCase()
              .includes(" " + searchString.toLocaleLowerCase()) ||
              item?.n
                ?.toLowerCase()
                .includes("/" + searchString.toLocaleLowerCase()) ||
              item?.n
                ?.toLowerCase()
                .includes("." + searchString.toLocaleLowerCase()) ||
              item?.n
                ?.toLowerCase()
                .includes("(" + searchString.toLocaleLowerCase()) ||
              item?.n
                ?.toLowerCase()
                .includes("-" + searchString.toLocaleLowerCase()) ||
              item?.n
                ?.toLowerCase()
                .includes("," + searchString.toLocaleLowerCase()) ||
              item?.n
                ?.toLowerCase()
                .indexOf(searchString.toLocaleLowerCase()) === 0),
        ),
      );
    return filteredData;
  };

  function selectContract(instrumentId: any) {
    setselectedInstrumentId(() => instrumentId);
    getStrategy(instrumentId);
    setcontractStep(1);
  }

  function selectStrategy(
    strategyId: any,
    instrumentId: any,
    forwardMonths: any,
  ) {
    setselectedStrategyId(strategyId);
    getContractsForInstrument(strategyId, instrumentId, forwardMonths);
  }

  function selectContractMonths(
    strategyId: any,
    instrumentId: any,
    contractMonthsValue: any,
  ) {
    setForwardMonths(contractMonthsValue);
    getContractsForInstrument(strategyId, instrumentId, contractMonthsValue);
  }

  useEffect(() => {
    strategies &&
      selectedInstrumentId &&
      selectStrategy(strategies[0]?.id, selectedInstrumentId, forwardMonths);
  }, [strategies]);

  function toggleActiveGroup() {
    setFabButtonOptions((prev) => !prev);

    if (selectedTradingGroupValue.current == null) return;

    setTradingGridGroupLiveView((prev) => {
      const newLiveViewData = [...prev];
      const index = newLiveViewData.findIndex(
        (ele) => ele?.id === selectedTradingGroupValue.current,
      );
      if (index === -1) {
        newLiveViewData.push({
          id: selectedTradingGroupValue.current,
          live: true,
        });
      } else {
        newLiveViewData.splice(index, 1);
      }
      return newLiveViewData;
    });

    CMEDfirebaseLogEvent(
      firebaseEventConfig.CMEDComponentNames.CMED_MARKET_DATA,
      firebaseEventConfig.eventNames.CMED_MARKET_DATA
        .CMED_MARKET_DATA_LIVE_VIEW,
    );
  }

  const saveTradingGridGroupOrder = () => {
    const tradingGridIds = tradingGridGroup?.map((item: any) => item?.id) || [];

    const newGridGroupEntry = {
      p: currentSelectedProfile,
      g: tradingGridIds,
    };

    const currentGridGroups: any[] = JSON.parse(
      userPreferences?.tradinggridgroupsorder || "[]",
    );

    const profileIndex = currentGridGroups.findIndex(
      (entry: any) => entry?.p === currentSelectedProfile,
    );

    let updatedGridGroups: any[] = [];

    // Means doesn't exist, create a new object and enter the data (ADD)
    if (profileIndex === -1) {
      updatedGridGroups = [...currentGridGroups, newGridGroupEntry];
    } else {
      // check first time if the data is already there in the cmed response while the application is closed and if something is missing or added while the application is closed, simply delete that by index or add it at the end.
      if (isSnapshot) {
        // 1. Get the list of IDs currently present in the source data
        const sourceIds = tradingGridGroup?.map((item: any) => item?.id) || [];

        updatedGridGroups = currentGridGroups
          .map((entry: any) => {
            if (entry?.p === currentSelectedProfile) {
              const existingGridIds: string[] = entry?.g || [];

              // 2. Remove IDs that no longer exist in tradingGridGroup
              const filteredExisting = existingGridIds.filter((id) =>
                sourceIds.includes(id),
              );

              // 3. Find IDs that are in tradingGridGroup but NOT yet in the profile
              const newIds = sourceIds.filter(
                (id) => !filteredExisting.includes(id),
              );

              // 4. Return entry with existing IDs (preserved order) + new IDs at the end
              return {
                ...entry,
                g: [...filteredExisting, ...newIds],
              };
            }
            return entry;
          })
          .filter(Boolean);
      } else {
        // Profile exists, so UPDATE the existing entry
        const idsToDeleteFromBackend: string[] = deletedGrids || [];
        const idToAddorUpdateFromBackend: string = addedOrUpdatedGrid || "";

        updatedGridGroups = currentGridGroups
          .map((entry: any) => {
            if (entry?.p === currentSelectedProfile) {
              const existingGridIds: string[] = entry?.g || [];
              let newArray: string[] = existingGridIds;
              if (idsToDeleteFromBackend.length > 0) {
                newArray = existingGridIds.filter(
                  (item) => !idsToDeleteFromBackend.includes(item),
                );
              } else if (idToAddorUpdateFromBackend?.length > 0) {
                const isAlreadyPresent = existingGridIds.includes(
                  idToAddorUpdateFromBackend,
                );
                if (!isAlreadyPresent) {
                  newArray = [...newArray, idToAddorUpdateFromBackend];
                }
              } else {
                newArray = existingGridIds;
              }
              return {
                p: newGridGroupEntry?.p,
                g: newArray,
              };
            }
            return entry;
          })
          .filter(Boolean);

        setDeletedGrids(undefined);
        setAddedOrUpdatedGrid(undefined);
      }
    }

    const updatedPreferences: UserPreferences = {
      ...userPreferences,
      tradinggridgroupsorder: JSON.stringify(updatedGridGroups),
    };

    setUserPreferences(updatedPreferences);

    saveUserPreferences(updatedPreferences);
  };

  useEffect(() => {
    if (
      userPreferences?.id !== undefined &&
      currentSelectedProfile !== undefined &&
      tradingGridGroup !== undefined &&
      tradingGridGroup?.length >= 0
    ) {
      saveTradingGridGroupOrder();
    }
  }, [
    tradingGridGroup,
    userPreferences?.id,
    currentSelectedProfile,
    deletedGrids,
    addedOrUpdatedGrid,
  ]);

  if (
    isLoadingMarketData &&
    (!currentTradingGroupData || currentTradingGroupData.length === 0)
  ) {
    return <Skeleton__MarketData />;
  } else if (
    (tradingGridGroup === undefined || tradingGridGroup?.length === 0) &&
    (isSnapshot === true || isSnapshot === null)
  ) {
    return <ShowInMobileErrorBackdrop />;
  }

  return (
    <>
      <IonSegment scrollable={true} value={selectedTradingGroupValue?.current}>
        {JSON.parse(userPreferences?.tradinggridgroupsorder || "[]")
          .find((item: any) => item?.p === currentSelectedProfile)
          ?.g?.map((item: any) => {
            const gridData = tradingGridGroupGetter(tradingGridGroup, item);
            if (!gridData) return null;
            return (
              <IonSegmentButton
                key={item}
                value={item}
                onClick={(e: any) => {
                  selectedTradingGroupValue?.current &&
                    selectedTradingGroupValue?.current !== e?.target?.value &&
                    unsubscribeTradingGridGroupItemMarketData(
                      selectedTradingGroupValue.current,
                    );
                  setCurrentTradingGroup(e?.target?.value);
                  selectedTradingGroupValue.current = e?.target?.value;
                  updateGridGroupPreference();
                }}
                layout="icon-start"
              >
                <IonLabel>{gridData.n}</IonLabel>
                <IonIcon
                  color={`${
                    tradingGridGroupLiveView?.find((ele) => ele?.id === item)
                      ?.live
                      ? "success"
                      : ""
                  }`}
                  icon={`${
                    tradingGridGroupLiveView?.find((ele) => ele?.id === item)
                      ?.live
                      ? folderOpen
                      : folderOpenOutline
                  }`}
                  size="small"
                ></IonIcon>
              </IonSegmentButton>
            );
          })}
      </IonSegment>
      <RenderMobileHeader />
      <IonContent style={{ "--padding-bottom": "80px" }}>
        <IonList
          className="ion-no-padding"
          lines="none"
          style={{ background: "transparent" }}
        >
          {currentTradingGroupData
            ?.filter((item: any) =>
              tradingGridGroupLiveView?.find(
                (ele) => ele?.id === selectedTradingGroupValue.current,
              )?.live
                ? (item && item?.b && item?.b?.r && item?.b?.r !== 0) ||
                  (item && item?.boq && item?.boq?.r && item?.boq?.r !== 0)
                : item,
            )
            ?.map((elem, index) => (
              <NewMarketDataListItem
                key={elem.id}
                userCMEDEntitlements={userCMEDEntitlements}
                tradingGridGroupData={elem}
                currentTradingGridGroup={currentTradingGroup}
                itemIndex={index}
                setOpenOrderEntryModal={setOpenOrderEntryModal}
                setOrderEntryType={setOrderEntryType}
                setOrderEntryData={setOrderEntryData}
                setOrderEntryData_Live={setOrderEntryData_Live}
                OpenOrderEntryModal={openOrderEntryModal}
                OrderEntryType={orderEntryType}
                selectedOrderAgressionItem={setselectedOrderAgressionItem}
                orderAggression={orderAggression}
                setorderAggression={setorderAggression}
                orderEntryData={orderEntryData}
                orderEntryData_Live={orderEntryData_Live}
              />
            ))}
        </IonList>
      </IonContent>

      <OrderEntryModal
        type="futures"
        selectedOption={undefined}
        orderEntryType={orderEntryType}
        openOrderEntryModal={openOrderEntryModal}
        setOpenOrderEntryModal={setOpenOrderEntryModal}
        orderEntryData={orderEntryData}
        orderEntryData_Live={orderEntryData_Live}
        userCMEDEntitlements={userCMEDEntitlements}
        componentusedIn="marketData"
        priceType={priceType}
        setpriceType={setpriceType}
      />
      <div id="add-a-contract-modal" style={{ display: "none" }}>
        <IonButton id="open-modal" expand="block">
          Open
        </IonButton>
      </div>
      <IonFab
        activated={fabButtonOptions}
        id="IonFabButton"
        data-testid="IonFabButton"
        slot="fixed"
        vertical="bottom"
        horizontal="end"
      >
        <IonFabButton
          data-testid="markets-fab-button"
          color={"secondary"}
          size="small"
          style={{ opacity: 0.8 }}
          onClick={() => setFabButtonOptions(!fabButtonOptions)}
        >
          <IonIcon icon={ellipsisHorizontal}></IonIcon>
        </IonFabButton>
        <IonFabList side="top">
          <IonFabButton
            id="AddContracts"
            title="Add Contracts"
            onClick={() => {
              setAddContractModalOpen(true);
              setFabButtonOptions(!fabButtonOptions);
            }}
          >
            <IonIcon icon={add}></IonIcon>
          </IonFabButton>
          <IonFabButton
            title="Live View"
            id="TurnOnLiveAndOff"
            data-testid="TurnOnLiveAndOff"
            onClick={toggleActiveGroup}
          >
            <IonIcon
              color={`${
                tradingGridGroupLiveView?.find(
                  (ele) => ele?.id === selectedTradingGroupValue.current,
                )?.live
                  ? "success"
                  : ""
              }`}
              icon={statsChart}
            ></IonIcon>
          </IonFabButton>
          <IonFabButton
            id="EditGrids"
            title="Edit"
            onClick={() => {
              setIsEditGridsModalOpen(true);
              setFabButtonOptions(!fabButtonOptions);
              CMEDfirebaseLogEvent(
                firebaseEventConfig.CMEDComponentNames.CMED_MARKET_DATA,
                firebaseEventConfig.eventNames.CMED_MARKET_DATA
                  .CMED_MARKET_DATA_EDIT_GRIDS,
              );
            }}
          >
            <IonIcon icon={list}></IonIcon>
          </IonFabButton>
        </IonFabList>
      </IonFab>
      <IonModal
        isOpen={addContractModalOpen}
        onDidDismiss={() => setForwardMonths(1)}
      >
        <IonHeader className="ion-no-border">
          <IonToolbar>
            {contractStep !== 0 && (
              <IonButtons slot="start">
                <IonButton
                  onClick={() => {
                    setcontractStep(contractStep - 1);
                    setContractSearchVal("");
                    setStrategySearchVal("");
                    setPeriodSearchVal("");
                    setFinalContractSearchVal("");
                    setSelectedFutureContractsCheckboxes([]);
                    setForwardMonths(1);
                  }}
                >
                  Back
                </IonButton>
              </IonButtons>
            )}
            <IonTitle>
              {contractStep === 0 && <>Add New Contract</>}
              {contractStep === 1 && <>Select Contract</>}
            </IonTitle>
            <IonButtons slot="end">
              <IonButton
                onClick={() => {
                  setAddContractModalOpen(false);
                  setcontractStep(0);
                  setContractSearchVal("");
                  setStrategySearchVal("");
                  setPeriodSearchVal("");
                  setFinalContractSearchVal("");
                  setSelectedFutureContractsCheckboxes([]);
                }}
              >
                Close
              </IonButton>
            </IonButtons>
          </IonToolbar>
          <IonToolbar>
            <IonList
              inset={true}
              style={{ "padding-bottom": "0", "margin-top": "0" }}
            >
              <IonSearchbar
                placeholder="Search..."
                value={
                  contractStep === 0
                    ? contractSearchVal
                    : contractStep === 1
                      ? finalContractSearchVal
                      : ""
                }
                onIonInput={(ev: any) =>
                  contractStep === 0
                    ? setContractSearchVal(ev.detail.value)
                    : contractStep === 1
                      ? setFinalContractSearchVal(ev.detail.value)
                      : ""
                }
                // autocapitalize="off"
                className="ion-no-padding"
                disabled={allContracts === undefined}
                ref={searchRef}
                style={{ "padding-bottom": "0" }}
              ></IonSearchbar>
            </IonList>
            {contractStep === 1 && (
              <IonList inset={true}>
                <IonItem lines="none" color="light">
                  <IonSelect
                    id="strategy"
                    label="Strategy"
                    placeholder={
                      strategies?.length === 0 ? "Loading..." : "Select"
                    }
                    interface="action-sheet"
                    disabled={strategies?.length === 0}
                    value={selectedStrategyId}
                    onIonChange={(e: any) => {
                      setSelectedFutureContractsCheckboxes([]);
                      selectStrategy(
                        e.detail.value,
                        selectedInstrumentId,
                        forwardMonths,
                      );
                    }}
                  >
                    {strategies?.map((elem: any, index: any) => (
                      <IonSelectOption value={elem?.id} key={index}>
                        {elem?.n}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
              </IonList>
            )}
            {contractStep === 1 && (
              <IonList inset={true}>
                <IonItem lines="none" color="light">
                  <IonSelect
                    id="terms"
                    label="Terms"
                    placeholder={
                      contractMonthsOptions?.length === 0
                        ? "Loading..."
                        : "Select"
                    }
                    interface="action-sheet"
                    value={forwardMonths}
                    onIonChange={(e: any) => {
                      selectContractMonths(
                        selectedStrategyId,
                        selectedInstrumentId,
                        e.detail.value,
                      );
                    }}
                  >
                    {contractMonthsOptions?.map((elem: any, index: any) => (
                      <IonSelectOption value={elem?.value} key={index}>
                        {elem?.name}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
              </IonList>
            )}
          </IonToolbar>
        </IonHeader>
        <AddNewContractHeader />
        <IonContent>
          {allContracts === undefined && (
            <IonList inset={true}>
              <IonItem lines="none" color="danger">
                <IonIcon icon={informationCircle} slot="start"></IonIcon>
                <IonLabel>Contract Search service unavailable</IonLabel>
              </IonItem>
            </IonList>
          )}
          {doFilterItOut(allContracts, contractSearchVal, "")?.length === 0 && (
            <IonList inset={true}>
              <IonItem lines="none" color="warning">
                <IonIcon icon={informationCircle} slot="start"></IonIcon>
                <IonLabel>No contract found</IonLabel>
              </IonItem>
            </IonList>
          )}

          {allContracts !== undefined &&
          contractStep === 0 &&
          contractSearchVal === ""
            ? doFilterItOut(
                allContracts?.slice(0, 150),
                contractSearchVal,
                "AllContracts",
              ).map((contract: AllContracts, index: number) => (
                <IonItem
                  button
                  lines="full"
                  className={index % 2 === 0 ? "even_item_bg" : ""}
                  key={index + 999}
                >
                  <IonGrid>
                    <IonRow
                      onClick={() => {
                        selectContract(contract?.id);
                        // instrumentId = contract?.id;
                      }}
                    >
                      <IonCol>{contract?.c}</IonCol>
                      <IonCol>{contract?.n}</IonCol>
                    </IonRow>
                  </IonGrid>
                </IonItem>
              ))
            : allContracts !== undefined &&
              contractStep === 0 &&
              contractSearchVal !== "" &&
              doFilterItOut(
                allContracts,
                contractSearchVal,
                "AllContracts",
              ).map((contract: AllContracts, index: number) => (
                <IonItem
                  button
                  lines="full"
                  className={index % 2 === 0 ? "even_item_bg" : ""}
                  key={index}
                >
                  <IonGrid>
                    <IonRow
                      onClick={() => {
                        selectContract(contract?.id);
                        // instrumentId = contract?.id;
                      }}
                    >
                      <IonCol>{contract?.c}</IonCol>
                      <IonCol style={{ overflowWrap: "anywhere" }}>
                        {contract?.n}
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonItem>
              ))}
          {contractStep === 1 &&
            (contractRetrievalStarted && finalContracts === undefined
              ? setTimeout(() => {
                  setShowNoContractsMessage(true);
                }, 1500) &&
                showNoContractsMessage && ( // Add parentheses and && condition
                  <IonList inset={true}>
                    <IonItem lines="none" color="warning">
                      <IonIcon icon={informationCircle} slot="start"></IonIcon>
                      <IonLabel>No contracts available to display.</IonLabel>
                    </IonItem>
                  </IonList>
                )
              : finalContracts !== undefined && ( // Correct closing parenthesis here
                  <IonList>
                    {doFilterItOut(
                      finalContracts,
                      finalContractSearchVal,
                      "Contracts",
                    ).map(
                      (
                        finalContract: Contracts,
                        index: number, // Correct parentheses here
                      ) => {
                        const isContractAlreadyAdded =
                          currentTradingGroupData?.some(
                            (existingContract: any) =>
                              existingContract?.ii?.toString() ===
                                finalContract?.id?.toString() ||
                              existingContract?.id?.toString() ===
                                finalContract?.id?.toString(),
                          );
                        return (
                          <IonItem
                            color="light"
                            lines="full"
                            key={finalContract?.id}
                            disabled={isContractAlreadyAdded}
                            style={
                              isContractAlreadyAdded
                                ? { opacity: 0.5, pointerEvents: "none" }
                                : {}
                            }
                          >
                            <IonCheckbox
                              labelPlacement="end"
                              justify="start"
                              className="ion-text-wrap"
                              onIonChange={(event) =>
                                handleCheckboxChange(event)
                              } // Pass event and id
                              value={finalContract?.id}
                              checked={
                                isContractAlreadyAdded ||
                                selectedFutureContractsCheckboxes.includes(
                                  finalContract?.id,
                                )
                              }
                              disabled={isContractAlreadyAdded}
                            >
                              {finalContract.n}
                            </IonCheckbox>
                          </IonItem>
                        );
                      },
                    )}
                  </IonList>
                ))}
        </IonContent>
        {contractStep === 1 && (
          <IonFooter>
            <IonToolbar>
              <IonButton
                expand="block"
                onClick={() => {
                  addInstrumentToGrid();
                  setContractSearchVal("");
                  setStrategySearchVal("");
                  setPeriodSearchVal("");
                  setFinalContractSearchVal("");
                  setcontractStep(0);
                  setFinalContracts(undefined);
                  setSelectedFutureContractsCheckboxes([]);
                  setAddContractModalOpen(false);
                }}
                disabled={selectedFutureContractsCheckboxes.length === 0}
              >
                Select
              </IonButton>
            </IonToolbar>
          </IonFooter>
        )}
      </IonModal>
      <EditGridsModal
        isOpen={isEditGridsModalOpen}
        setIsOpen={setIsEditGridsModalOpen}
        currentSelectedProfile={currentSelectedProfile}
        tradingGridGroup={tradingGridGroup}
        currentTradingGroup={currentTradingGroup}
        setCurrentTradingGroup={setCurrentTradingGroup}
        selectedTradingGroupValue={selectedTradingGroupValue}
        updateGridGroupPreference={updateGridGroupPreference}
        unsubscribeTradingGridGroupItemMarketData={unsubscribeTradingGridGroupItemMarketData}
      />
    </>
  );
};

export default memo(MarketDataContainer);
